<app-header [title]="'Passports'" [notificationsCount]="commentsNotification.unreadCount()" [showSearchIcon]="true" [showFilterIcon]="true" [showDesktopFilters]="true" [filterDefinitions]="shuntingFilters" (refresh)="onRefresh()"></app-header>

<div class="shunting-page" [style.paddingTop.px]="(ui.searchOpen() || ui.filtersOpen()) ? 0 : 50">
  <!-- Mobile View -->
  <div class="mobile-view">
    <app-no-passports *ngIf="visibleRecords.length === 0"></app-no-passports>
    
    <ng-container *ngFor="let rec of visibleRecords; trackBy: trackById; let i = index">
      <app-shunting-passport-cell 
        [recordId]="rec.id"
        [loadNumber]="rec.loadNumber || ''"
        [scheduledText]="((rec.dueDateTime) | dateWithOrdinal:'EEE, d MMM y, HH:mm') || 'No scheduled date'"
        [vendorName]="rec.vendorName || ''"
        [variety]="rec.variety || ''"
        [bulkerNumber]="rec.bulker || ''"
        [haulier]="rec.haulier || ''"
        [vendorNumber]="rec.vendorNumber || ''"
        [origin]="rec.origin || ''"
        [destination]="rec.destinationWeighbridge || rec.destination || ''"
        [apn]="rec.apn || ''"
        [apnName]="rec.apnName || ''"
        [growerName]="rec.growerName || ''"
        [bulker]="rec.bulker || ''"
        [status]="rec.status"
        [styleState]="rec.pcrChangeAlert ? 'pcr-change' : (rec.statusName?.toLowerCase() === 'cancelled' ? 'cancelled' : 'default')">
      </app-shunting-passport-cell>
      <div class="passport-cell-spacer"></div>
    </ng-container>
  </div>

  <!-- Desktop View -->
  <div class="desktop-view">
    @let shuntingDesktopRows = sortedPaginatedRecords;
    @if (shuntingDesktopRows.length > 0) {
      <!-- Main White Container -->
      <div class="desktop-main-container">
        <!-- Status Row with Show Rows dropdown and Refresh -->
        <div class="desktop-status-row">
          <app-desktop-status-row
            [itemsPerPage]="itemsPerPage"
            [rowsDropdownOpen]="rowsDropdownOpen"
            (toggleRowsDropdown)="toggleRowsDropdown($event)"
            (setItemsPerPage)="setItemsPerPage($event)"
            (refresh)="onRefresh()">
          </app-desktop-status-row>
        </div>

        <!-- Table Container -->
        <div class="desktop-table-container">
          <table class="desktop-passports-table">
            <thead>
              <tr>
                <th (click)="onSort('loadNumber')" (keydown.enter)="onSort('loadNumber')" (keyup.enter)="onSort('loadNumber')" tabindex="0">Load <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('scheduled')" (keydown.enter)="onSort('scheduled')" (keyup.enter)="onSort('scheduled')" tabindex="0">Scheduled <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('vendorCombined')" (keydown.enter)="onSort('vendorCombined')" (keyup.enter)="onSort('vendorCombined')" tabindex="0">Vendor Number/Name <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('variety')" (keydown.enter)="onSort('variety')" (keyup.enter)="onSort('variety')" tabindex="0">Variety <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('origin')" (keydown.enter)="onSort('origin')" (keyup.enter)="onSort('origin')" tabindex="0">Origin <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('destination')" (keydown.enter)="onSort('destination')" (keyup.enter)="onSort('destination')" tabindex="0">Destination <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('haulier')" (keydown.enter)="onSort('haulier')" (keyup.enter)="onSort('haulier')" tabindex="0">Haulier <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('apnName')" (keydown.enter)="onSort('apnName')" (keyup.enter)="onSort('apnName')" tabindex="0">APN/Name <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th (click)="onSort('bulkerNumber')" (keydown.enter)="onSort('bulkerNumber')" (keyup.enter)="onSort('bulkerNumber')" tabindex="0">Bulker Number <img src="/assets/images/Sort.png" class="sort-icon" alt="sort"></th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (rec of shuntingDesktopRows; track trackById($index, rec)) {
                <tr [attr.data-passport-id]="rec.id"
                    [class.has-pcr-changes]="rec.pcrChangeAlert && rec.statusName?.toLowerCase() !== 'cancelled'"
                    [class.is-cancelled]="rec.statusName?.toLowerCase() === 'cancelled'">
                  <td class="col-load-number" 
                      (click)="rec.statusName?.toLowerCase() !== 'cancelled' && openPassportDetails(rec.id)" 
                      (keydown.enter)="rec.statusName?.toLowerCase() !== 'cancelled' && openPassportDetails(rec.id)" 
                      (keyup.enter)="rec.statusName?.toLowerCase() !== 'cancelled' && openPassportDetails(rec.id)" 
                      [tabindex]="rec.statusName?.toLowerCase() !== 'cancelled' ? 0 : -1">
                    {{ store.get(rec.id)?.loadNumber || rec.id }}
                  </td>
                  <td>
                    <app-formatted-date [dueDateTime]="store.get(rec.id)?.dueDateTime"></app-formatted-date>
                  </td>
                  <td>{{ (store.get(rec.id)?.vendorNumber || '') + ' - ' + (store.get(rec.id)?.vendorName || '') }}</td>
                  <td>{{ store.get(rec.id)?.variety || '-' }}</td>
                  <td>{{ store.get(rec.id)?.origin || 'No Origin Field' }}</td>
                  <td>{{ store.get(rec.id)?.destinationWeighbridge || store.get(rec.id)?.destination || '-' }}</td>
                  <td>{{ store.get(rec.id)?.haulier || '-' }}</td>
                  <td>{{ store.get(rec.id)?.apnName || store.get(rec.id)?.apn || '-' }}</td>
                  <td>{{ store.get(rec.id)?.bulkerMain || store.get(rec.id)?.bulkerNumber || '-' }}</td>
                  <app-action-buttons 
                    [recordId]="rec.id"
                    (history)="openHistory($event)"
                    (comments)="openComments($event)">
                  </app-action-buttons>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <app-desktop-pagination 
          [currentPage]="currentPage"
          [itemsPerPage]="itemsPerPage"
          [totalPages]="totalPages"
          [visibleRecordsLength]="visibleRecords.length"
          (pageChange)="onPageChange($event)">
        </app-desktop-pagination>
      </div>
    } @else {
      <div class="desktop-empty-container">
        <!-- Status Row for Empty State -->
        <div class="desktop-main-container empty-state-header">
          <div class="desktop-status-row">
            <app-desktop-status-row 
              [itemsPerPage]="itemsPerPage"
              [rowsDropdownOpen]="rowsDropdownOpen"
              (toggleRowsDropdown)="toggleRowsDropdown($event)"
              (setItemsPerPage)="setItemsPerPage($event)"
              (refresh)="onRefresh()">
            </app-desktop-status-row>
          </div>
        </div>

        <app-desktop-empty-state></app-desktop-empty-state>
      </div>
    }
  </div>
</div>

<app-loading-spinner [isLoading]="isLoading()" [largeOnDesktop]="true" text="Loading passports…"></app-loading-spinner>

<app-navbar [items]="navbarItems" [selectedId]="'home'" (selectedIdChange)="onNavChange($event)"></app-navbar>
